<template>
  <div class="c-shopping-list__row" :class="{ 'c-shopping-list__row--selected': isOrdered }">
    <span v-if="!isHeaderLine" class="c-shopping-list__thumbnail" :style="'background-image: url(' + productPreviewImg + ');'" @click="popupProduct(product)">
      &nbsp;
    </span>
    <div class="c-shopping-list__text">
      <div class="c-shopping-list__description">
        <component :is="ProductControl" v-bind="{ productNode, isRequired, selectedIds, isOrdered, isHeaderLine }" @change="toggleProduct($event)" />
      </div>
      <div v-if="!isHeaderLine" class="c-shopping-list__price">
        <span v-if="!quantityEnabled">{{ quantity }}</span>
        <input v-else type="number" class="c-textfield" placeholder="0" :value="quantity" :min="0" @change="handleSetQuantity" :readonly="!quantityEnabled" />
        <span class="u-text-times">×</span>
        <div class="c-shopping-list__price-label">{{ costPerUnitWithVat }} euro</div>
      </div>
      <!-- <div class="c-shopping-list__note" :class="{ ' js-collapsed': collapseDescription }" @click="collapseDescription = !collapseDescription">
        {{ product.description }}
      </div> -->
      <div class="c-shopping-list__note" :class="{ ' js-collapsed': collapseDescription }" @click="collapseDescription = !collapseDescription">
        <div v-html="productHtmlDescription"></div>
        <div v-if="isProductSet">Pakket met {{ productSetItemsSummary }}.</div>
      </div>
    </div>
  </div>
</template>

<script>
import cmp from "./";

export default {
  ...cmp,
};
</script>
